/**
 * Asynchronously loads the component for DormantCampaignsLeadsFilterPage
 */

import { lazyLoad } from 'utils/loadable';

export const DormantCampaignsLeadsFilterPage = lazyLoad(
  () => import('./index'),
  module => module.DormantCampaignsLeadsFilterPage,
);
